// ER-2932 (Loi Koopkracht): display of the conditional discounts, excluded from the
// advertised price and shown apart under the "Cashback" label, one line per condition code.
// Needs `isPro` on the component to pick the VAT included / excluded amount.

import { conditionalDiscountLines } from "@/helpers/conditionalDiscounts";

const cashback = {
  methods: {
    cashbackLines(products) {
      const keyByCustomerType = this.isPro ? 'priceEuro' : 'priceEuroVAT';

      return conditionalDiscountLines(products).map(line => ({
        code: line.code,
        amount: line[keyByCustomerType]
      }));
    },
    cashbackTotal(products) {
      return this.cashbackLines(products).reduce((total, line) => total + line.amount, 0);
    },
    cashbackMention(code) {
      return this.$t(`cashback.mention.${code.replace('-', '')}`);
    }
  }
}

export default cashback;



// WEBPACK FOOTER //
// ./src/mixins/cashback.js